import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { Fund } from '../types';

export const useUpdateFund = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading } = useMutation<
    { data: Fund },
    Error,
    Partial<Fund> & { id: string }
  >({
    mutationFn: fund => api.put<Fund>(`funds/${fund.id}`, fund),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['funds'] });
    },
  });

  const updateFund = async (fund: Partial<Fund> & { id: string }) => {
    return mutateAsync(fund);
  };

  return {
    updateFund,
    isLoading,
  };
};
